<template>
    <div v-show="active" class="block origin-top-right absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-md border py-2 z-10 transition duration-300 animate-in slide-in-from-top-3">
      <slot/>
    </div>
  </template>
  
  <script>
    export default {
      name: 'AppDropdownContent',
      inject: ['sharedState'],
      computed: {
        active () {
          return this.sharedState.active
        }
      }
    }
  </script>